module.exports = __webpack_public_path__ + "img/Jump Casting95.553c30ab.jpg";